<div class="geocoding-map-container">
  <div class="map-wrapper">
    <tf-mapbox-map
      [center]="initialCenter"
      [zoom]="defaultZoom"
      (mapLoad)="onMapLoad($event)"></tf-mapbox-map>
  </div>
</div>
